import { useGlobalStore } from "@/store/GlobalStore";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import request from "project-config/services/request/request";
import { createContainer } from "unstated-next";
import { getDomain } from "project-config/utils/domain";
import { BillDetailsTabsKey, BillTabTypeEnum } from "../constants";

interface IStatistic {
  voucherFeeAmountTotal: number;
  feeAmountTotal: number;
  couponFeeAmountTotal: number;
  couponQYFeeAmountTotal: number;
}

export function useConsumeHook() {
  const { isDomestic } = useGlobalStore();

  const { t } = useTranslation("center");
  const unit = isDomestic ? "¥" : "$";

  const [statistic, setStatistic] = useState<IStatistic>();
  const [tip, setTip] = useState("");
  const [activeKey, setActiveKey] = useState<BillTabTypeEnum>(
    BillTabTypeEnum.ConsumerOverview
  );
  const [billDetailsActiveKey, setBillDetailsActiveKey] =
    useState<BillDetailsTabsKey>(BillDetailsTabsKey.VolumeDetail);

  useEffect(() => {
    const warning1 = `${t("consumption_warning_consume_1")} ${unit} ${
      statistic?.feeAmountTotal ?? 0
    }`;
    const warning2 = `${t("consumption_warning_consume_2")} ${unit} ${
      statistic?.couponFeeAmountTotal ?? 0
    }`;
    const warning3 = `${t("consumption_warning_consume_3")} ${unit} ${
      statistic?.couponQYFeeAmountTotal ?? 0
    }`;
    const warning4 = `${t("consumption_warning_consume_4")} ${unit} ${
      statistic?.voucherFeeAmountTotal ?? 0
    }`;
    const tip =
      `${warning1}，${warning2}` +
      (!getDomain() ? `，${warning3}` : "") +
      (!getDomain() ? `，${warning4}` : "");

    setTip(tip);
  }, [t, unit, statistic]);

  const fetchBillConsume = async (queryParams: any) => {
    const { data } = await request.post(
      "/api/rendering/user/consume/bill/getUserBillTotalConsume",
      queryParams
    );

    setStatistic(data);
  };

  return {
    fetchBillConsume,
    tip,
    activeKey,
    setActiveKey,
    billDetailsActiveKey,
    setBillDetailsActiveKey,
  };
}

const ConsumeContainer = createContainer(useConsumeHook);

export const ConsumeProvider = ConsumeContainer.Provider;

export function useConsumeStore() {
  return ConsumeContainer.useContainer();
}
